import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBlockComponent } from "./med-icon-block.component";

@NgModule({
  declarations: [
    MedIconBlockComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBlockComponent,
  ],
})
export class MedIconBlockModule { }
